<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    {{ 'news.new' | translate }}
  </div>
  <app-segment-list [segmentValue]="segment()"
    [segmentButtons]="segmentButtons()"
    (segmentChanged)="segment.set($event)">
  </app-segment-list>
  @if (sites$ | async; as sites) {
    <div>
      <app-select-site-button [items]="sites"
        [multiple]="true"
        [selectedSite]="selectedSites()"
        (selected)="onSites($event)"></app-select-site-button>
    </div>
  } @else {
    <app-loading></app-loading>
  }
  @if (selectedSites().length === 1) {
    <div class="ion-margin-top">
      <app-select-area-button [onlyResidences]="true"
        [multiple]="true"
        [selectedItem]="selectedAreas()"
        [site]="selectedSites()[0]"
        [title]="'site.room.room'"
        (selected)="onArea($event)"></app-select-area-button>
    </div>
  }
  <form class="ion-padding-bottom"
    [formGroup]="formGroup">
    <h3>{{ 'news.title' | translate }}</h3>
    <ion-item lines="none">
      <ion-input autocapitalize="on"
        formControlName="title"></ion-input>
    </ion-item>
    @if (segment() === 'normal') {
      <h3>
        {{ 'news.text' | translate }}
      </h3>
      <ion-item class="text"
        lines="none">
        <ion-textarea autocapitalize="on"
          formControlName="text"
          rows="10"
          autoGrow="true"></ion-textarea>
        <app-speech-to-text (text)="onMic($event)"></app-speech-to-text>
      </ion-item>
    } @else {
      <h3>
        {{ 'news.notes' | translate }}
      </h3>
      <ion-item class="text"
        lines="none">
        <ion-textarea autocapitalize="on"
          formControlName="text"
          [placeholder]="'news.notesInfo' | translate"
          rows="10"
          autoGrow="true"></ion-textarea>
        <app-speech-to-text (text)="onMic($event)"></app-speech-to-text>
      </ion-item>
      <div class="ion-margin-top">
        <ion-button color="light"
          shape="round"
          [disabled]="formGroup.get('text').invalid"
          (click)="useAI()">
          <app-loading-button [loading]="loading()">
            {{ 'news.useAI' | translate }}
          </app-loading-button>
        </ion-button>
      </div>
    }
    <ion-item lines="none">
      <ion-toggle aria-label=""
        formControlName="sendEmail">
        {{ 'news.sendEmail' | translate }}
      </ion-toggle>
    </ion-item>
    <div class="ion-margin-top">
      <ion-button color="light"
        shape="round"
        [disabled]="!formGroup.valid || selectedSites().length === 0"
        (click)="save()">{{ 'general.save' | translate }}</ion-button>
    </div>
  </form>
</app-main-dialog>